import { hasDmexBridge } from './bridgeRequest';

/**
 * 是否运行在 Dmex 客户端内、且工作号已被启动。
 *
 * 改造前这里看的是 `sessionStorage.tolink_token`（页面自己绑定换来的凭据）。
 * 现在页面不再持有任何 token，那个判断会**恒为 false**，于是未读数上报等依赖它的
 * 逻辑会静默失效（不报错，只是不再上报，很难发现）。
 *
 * 新语义：**有 dmex 桥 = 运行在客户端内**。而客户端只有在该账号已绑定工作组后
 * 才会启动它（未绑定会先拦下来引导绑定），所以「有桥」同时蕴含「已绑定、已启动」。
 *
 * 独立部署的 tweb（直接在浏览器打开）没有桥，因此不走依赖客户端的那部分逻辑 ——
 * 但它也无法调用业务接口（凭据在客户端手里），本来就只是半可用状态。
 */
export function isTolinkLogin(): boolean {
  return hasDmexBridge();
}
